import Colors from '@dynatrace/strato-design-tokens/colors';

import { type TextOverflowExpandOptions } from './types/marker.js';

export const DEFAULT_LABELS_WIDTH = 60;
export const DEFAULT_LABELS_OFFSET = 20;
export const TRACK_HEIGHT = 24;
export const TRACK_SEPARATOR_COLOR = Colors.Border.Neutral.Default;
export const EMPHASIZED_TRACK_SEPARATOR_COLOR = Colors.Border.Neutral.Accent;
export const TRACK_SEPARATOR_STROKE_WIDTH = 1;
export const TRACK_PADDING_Y = 1;

export const LABEL_OFFSET = 12;
export const PILL_MARKER_HEIGHT = 20;
export const OUTLINE_STROKE_WIDTH = 2;

export const DEFAULT_MARKER_COLOR = Colors.Charts.Categorical.Color01.Default;

export const MARKER_RADIUS = 10;
export const MINIMUM_MARKER_WIDTH = 3;
export const MARKER_OPACITY = 0.85;
export const MARKER_STROKE_WIDTH = 1;
export const MARKER_STROKE_COLOR = Colors.Background.Base.Default;
export const OUTER_CIRCLE_RADIUS = MARKER_RADIUS + OUTLINE_STROKE_WIDTH;

export const SCROLLBAR_THRESHOLD = 15;
export const SCROLLBAR_WIDTH = 8;
export const DEFAULT_ICON_COLOR = Colors.Text.Neutral.OnAccent.Default;

export const MARKER_PROPS = {
  opacity: MARKER_OPACITY,
  stroke: MARKER_STROKE_COLOR,
  strokeWidth: MARKER_STROKE_WIDTH,
};

export const DEFAULT_TRACK_HIDDEN = false;
export const DEFAULT_MARKER_PRIORITY = 0;
export const DEFAULT_MARKER_HIDDEN = false;
export const DEFAULT_TOOLTIP_Y_OFFSET = 40;
export const DEFAULT_SHOW_LABELS = true;
export const DEFAULT_TEXT_OVERFLOW = 'truncate';
export const DEFAULT_TRUNCATION_MODE = 'middle';
export const DEFAULT_INTEGRATION_TEXT_OVERFLOW_OPTIONS: TextOverflowExpandOptions =
  {
    textOverflow: 'expand',
  };

export const enum TestIds {
  Marker = 'marker',
  CircleMarker = 'circle-marker',
  PillMarker = 'pill-marker',
  Track = 'track',
  MarkerGroup = 'marker-group',
  AnnotationIndicator = 'annotation-indicator',
}

export const MARKER_ICON_OFFSET = 2;
export const MARKER_LABEL_PADDING = 6;
export const FOREIGN_OBJECT_THRESHOLD = 8;
export const MARKER_BORDER_RADIUS = 2;
export const MARKER_CONTENT_TO_BORDER_PADDING = 4;
export const MARGIN_TOP_STROKE = 1;
